import React from 'react';
import { TextField, MenuItem, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  date: React.RefObject<HTMLInputElement>;
  selectedHour: string;
  onChangeHour: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  disabled: boolean;
}

const DateHourPicker = ({ date, onChangeHour, selectedHour, label, disabled }: Props) => {
  const { t } = useTranslation('global');
  const hours = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  return (
    <Box sx={{ width: '100%', display: 'flex', gap: 1 }}>
      <TextField
        disabled={disabled}
        size="small"
        fullWidth
        type="date"
        label={label}
        inputRef={date}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
          },
        }}
      />

      <TextField
        disabled={disabled}
        select
        size="small"
        fullWidth
        label={t('promotion_page.Select Hour')}
        value={selectedHour}
        onChange={onChangeHour}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
          },
        }}
      >
        <MenuItem value="">
          <em>Select hour</em>
        </MenuItem>
        {hours.map((hour) => (
          <MenuItem key={hour} value={hour}>
            {`${hour}:00`}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

export default DateHourPicker;
